export default __webpack_public_path__ + "static/media/Roller Conveyors.250c831e.jpg";